import { COLLECTIONS_CLOSE_ITEM_DETAIL_PAGE } from './constants';

export function closeItemDetailPage() {
  return {
    type: COLLECTIONS_CLOSE_ITEM_DETAIL_PAGE,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CLOSE_ITEM_DETAIL_PAGE:
      return {
        ...state,
        selectedItemWithDetails: null,
        isOpenItemDetail: false,
      };

    default:
      return state;
  }
}
